/*
	© 2017 NetSuite Inc.
	User may not copy, modify, distribute, or re-bundle or otherwise make available this code;
	provided, however, if you are an authorized user with a NetSuite account or log-in, you
	may use this code subject to the terms that govern your access and use.
*/

// @module ProductDetails
define(
	'ProductDetails.Additional.Information.View'
,	[
		'LiveOrder.Model'

	,	'product_details_additional_information.tpl'

	,	'Backbone'
	, 'underscore'
	]
,	function (
		LiveOrderModel

	,	product_details_additional_information_tpl

	,	Backbone
	, _
	)
{
	'use strict';

	// @class ProductDetails.Additional.Information.View @extends Backbone.View
	return Backbone.View.extend({

			template: product_details_additional_information_tpl

			//@method getContext
			//@return {ProductDetails.Additional.Information.View.Context}
		,	getContext: function getContext ()
			{			
				var sds_pdfUrl = this.model.get('item').get('custitem_appf_sds_pdf_file_name');
				
				//@class ProductDetails.Additional.Information.View.Context
				return {
					//@property {Product.Model} model
					model: this.model
					//@property {String} manufacturer
				,	manufacturer: this.model.get('item').get('manufacturer')
					//@property {String} mpn
                ,	mpn:  this.model.get('item').get('mpn')
                    //@property {String} sku
				,	sku:  this.model.get('item').get('_sku')
				
				,	hasSDSheet: (sds_pdfUrl != null && sds_pdfUrl != '')? true:false
				
				,	SDSSheet:  sds_pdfUrl
				};
				//@class ProductDetails.Additional.Information.View
			}
		});
});

